export const state = () => ({
    isCookieBannerVisible: false,
    lastPageVisitDate: null,
    jobOffersLastCheckedDate: null,
});

export const mutations = {
    setCookieBannerVisibility(state, payload) {
        state.isCookieBannerVisible = payload;
    },
    setJobOffersLastCheckedDate(state, payload) {
        state.jobOffersLastCheckedDate = payload;
    },
};

export const actions = {
    openBanner({ commit }) {
        commit('setCookieBannerVisibility', true);
    },
    closeBanner({ commit }) {
        commit('setCookieBannerVisibility', false);
    },
};
